module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"crawlSuccess":"Crawled","createdAt":"Date created","delete":"Delete","fillSuccess":"Fill","mediaSuccess":"Illustrated","name":"Batch {0}","parseSuccess":"Parsed","pause":"Pause","rerun":"Re-run batch","retryFailed":"Retry failed","resume":"Resume","unprocessed":"Unprocessed","urlsInitial":"Seed"}}')
  delete Component.options._Ctor
}
